/**
 * Determines the target origin for postMessage communication from an iframe.
 *
 * @param originParam - Explicit origin passed as a query parameter from the parent
 * @param referrer - Referrer header value as a fallback
 * @returns The origin string to use for postMessage, or null if neither source is valid
 */
export const getTargetOrigin = (
  originParam: string | null,
  referrer: string | undefined
): string | null => {
  // Prefer explicit origin parameter passed from parent iframe
  // Note: URLSearchParams.get() already URL-decodes the value, so no need for decodeURIComponent
  if (originParam) {
    try {
      return new URL(originParam).origin
    } catch {
      // Invalid URL, fall through to referrer
    }
  }

  // Fall back to referrer header
  if (referrer) {
    try {
      return new URL(referrer).origin
    } catch {
      // Invalid referrer URL
    }
  }

  return null
}
